const yachoui = require("./src");

const req = require.context("./src", true, /^\.\/locale\/.+_.+\.tsx$/);

yachoui.locales = {};

req.keys().forEach((mod) => {
  const matches = mod.match(/\/([^/]+).tsx$/);
  yachoui.locales[matches[1]] = req(mod).default;
});
console.log({ yachoui });
module.exports = yachoui;
